import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { CategoryListModule } from 'src/app/libs/category-list/category-list.module'
import { AthletesListComponent } from './athletes-list.component'
import { AthletesListResolver } from './athletes-list.resolver'

@NgModule({
  imports: [CommonModule, CategoryListModule],
  declarations: [AthletesListComponent],
  providers: [AthletesListResolver]
})
export class AthleteListModule {}
